import {
  PriceRangeSelector,
  PrimaryAtmosphereSelector,
  AmenitiesSelector,
  ReservationPolicySelector,
} from '../../components/VenueForm';
import { VenueFormErrorBoundary } from '../../components/VenueForm/VenueFormErrorBoundary';
import { WarningTriangleIcon } from '../../components/ui/icons';
import { FormSection } from '../../components/ui/FormSection';
import type { PriceRange, PrimaryAtmosphere, Amenity, ReservationPolicy } from '@wineryxplorer/shared';

interface VenueDetailsSectionProps {
  submitError: string;
  priceRange: PriceRange | undefined;
  onPriceRangeChange: (value: PriceRange | undefined) => void;
  primaryAtmosphere: PrimaryAtmosphere | undefined;
  onPrimaryAtmosphereChange: (value: PrimaryAtmosphere | undefined) => void;
  amenities: Amenity[];
  onAmenitiesChange: (value: Amenity[]) => void;
  reservationPolicy: ReservationPolicy;
  onReservationPolicyChange: (value: ReservationPolicy) => void;
  errors: {
    priceRange?: string[];
    primaryAtmosphere?: string[];
    amenities?: string[];
  };
  isSaving: boolean;
}

export const VenueDetailsSection = ({
  submitError,
  priceRange,
  onPriceRangeChange,
  primaryAtmosphere,
  onPrimaryAtmosphereChange,
  amenities,
  onAmenitiesChange,
  reservationPolicy,
  onReservationPolicyChange,
  errors,
  isSaving,
}: VenueDetailsSectionProps) => (
  <FormSection title="Venue Details">
    {submitError && (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
        <div className="flex items-start space-x-2">
          <WarningTriangleIcon className="h-5 w-5 text-red-600 mt-0.5" />
          <div>
            <h3 className="text-sm font-medium text-red-800">Submission Error</h3>
            <p className="text-sm text-red-700 mt-1">{submitError}</p>
          </div>
        </div>
      </div>
    )}

    <VenueFormErrorBoundary>
      <div className="space-y-6">
        <PriceRangeSelector
          value={priceRange}
          onChange={onPriceRangeChange}
          error={errors.priceRange}
          loading={isSaving}
          disabled={isSaving}
        />

        <PrimaryAtmosphereSelector
          value={primaryAtmosphere}
          onChange={onPrimaryAtmosphereChange}
          error={errors.primaryAtmosphere}
          loading={isSaving}
          disabled={isSaving}
        />

        <AmenitiesSelector
          value={amenities}
          onChange={onAmenitiesChange}
          error={errors.amenities}
          loading={isSaving}
          disabled={isSaving}
        />

        <ReservationPolicySelector
          value={reservationPolicy}
          onChange={onReservationPolicyChange}
          loading={isSaving}
          disabled={isSaving}
        />
      </div>
    </VenueFormErrorBoundary>
  </FormSection>
);
